import { isNil } from "@etudescarre/utils";
import { apiClient } from "@/lib/api/client";
import type { paths } from "@/lib/api/schema";

export type AdminEmployeeListItem =
  paths["/api/admin/employees"]["get"]["responses"][200]["content"]["application/json"]["data"]["employees"][number];

export type FetchAllEmployeesResult =
  | { employees: AdminEmployeeListItem[]; status: number }
  | { employees: null; status: number };

const PAGE_SIZE = 100;

export async function fetchAllEmployees(): Promise<FetchAllEmployeesResult> {
  const employees: AdminEmployeeListItem[] = [];
  let page = 1;

  for (;;) {
    const { data, response } = await apiClient.GET("/api/admin/employees", {
      params: { query: { page, pageSize: PAGE_SIZE } },
    });
    if (isNil(data)) {
      return { employees: null, status: response.status };
    }
    employees.push(...data.data.employees);
    if (
      data.data.employees.length < PAGE_SIZE ||
      employees.length >= data.data.total
    ) {
      return { employees, status: response.status };
    }
    page += 1;
  }
}
